import React, {Component} from 'react';
import { iosCameraOutline } from 'react-icons-kit/ionicons';
// import Icon from 'react-icons-kit';
// import { close } from 'react-icons-kit/fa/close';
// import { iosContactOutline } from 'react-icons-kit/ionicons';
import Dropzone from 'react-dropzone';
import  UploadIcon  from './../assets/images/icon_upload.png'

/**
 * Image Upload and Preview Component for Member Section
 */

class FileUpload extends Component {
    constructor(props) {
        super(props)
    }

    handleUpload = (event) => {
        var extension = event.target.value.split(".").slice(-1)[0];
        if(extension==="png" || extension==="jpg" || extension==="jpeg") {
            var reader = new FileReader();
            reader.onloadend = () => {
                this.props.input.onChange(reader.result);
            }
            reader.readAsDataURL(event.target.files[0]);
        }
        else {
            alert("invalid file");
        }
    }

    toBase64 = (acceptedFiles, rejectedFiles) => {
        var reader = new FileReader();
        this.setState({ isLoading: true })
        reader.onloadend = () => {
            this.props.input.onChange(reader.result);
            this.setState({ isLoading: false })
        }
        reader.readAsDataURL(acceptedFiles[0]);
    }

    // componentDidUpdate(prevProps) {
    //     if(this.props.selectedAvatar !== prevProps.selectedAvatar) {
    //         fetch(require("images/avatars/"+this.props.selectedAvatar+".jpg"), {
    //             method: "GET",
    //         })
    //         .then(response => response.blob())
    //         .then(blob => {
    //             var reader = new FileReader();
    //             reader.onloadend = () => {
    //                 this.props.input.onChange(reader.result);
    //             }
    //             reader.readAsDataURL(blob);
    //         })
    //     }
    // }

    render() {
        // if(!this.props.input.value.length)
        if(true)
            return (
              <div className="uploadIconContainer">
                {/*<div className="addUtilityButton">
                        <div onClick={() => {this.refs.photo.click()}} className="addUtilityIcon" >
                            <Icon icon={iosCameraOutline} size={75} style={{ color: "#F08100", backgroundColor: "#FFF", borderRadius: "50%" }} />
                        </div>
                        <div className="addUtilityLabel">
                            Upload Photo
                        </div>
                        <input type="file"
                            onChange={this.handleUpload}
                            ref="photo"/>

                        {this.props.touched && this.props.error && <span className="error">{this.props.error}</span>}
                    </div>

                    <div className="addUtilityButton">
                        <div onClick={this.props.openAvatarModal} className="addUtilityIcon" >
                            <Icon icon={iosContactOutline} size={75} style={{ color: "#F08100", backgroundColor: "#FFF", borderRadius: "50%" }} />
                        </div>
                        <div className="addUtilityLabel">
                            Use Avatar
                        </div>
                    </div>*/}
                <Dropzone
                  accept="image/jpeg, image/png"
                  disableClick={true}
                  onDrop={(acc, rej) => {if(acc.length) this.toBase64(acc, rej); else alert("Not a valid Image");}}
                >
                  {({ getRootProps, getInputProps, open }) => (
                    <div
                      style={{ outline: "none" }}
                      // {...getRootProps({ refKey: "innerRef" })}
                    >
                      <input
                      //  {...getInputProps()}
                       />
                      <div className="centerText">
                        <img
                          src={UploadIcon}
                        />
                        <h1 className="subHeading">Member Image</h1>
                        <p className="content">
                          Drag & Drop
                          <br />{" "}
                          <div>your files or browse from</div>
                          <div>
                            <span
                              style={{
                                color: "#0A83AE",
                                cursor: "pointer",
                                textDecoration: "underline"
                              }}
                              onClick={open}
                            >
                              your computer
                            </span>{" "}
                            or{" "}
                            <span
                              style={{
                                color: "#0A83AE",
                                cursor: "pointer",
                                textDecoration: "underline"
                              }}
                              onClick={this.props.openAvatarModal}
                            >
                              okas library
                            </span>
                          </div>
                        </p>
						{
							this.props.meta.touched &&
							this.props.meta.error &&
							<p className="errorText">{this.props.meta.error}</p>
						}
                      </div>
                    </div>
                  )}
                </Dropzone>
              </div>
            );
        else
            return (
                <div className="imageUploadContainer">
                    <div className="closeIcon" style={{cursor: "pointer"}} onClick={ () => {this.props.input.onChange("")}}>
                        {/* <Icon icon={close}></Icon> */}
                    </div>
                    <img src={this.props.input.value} />
                </div>
            )
    }
}

export default FileUpload